const tableHeader = ['Categoria', 'Editar', 'Excluir'];

const Tablecadastro = [
  {
    id: 'nome',
    title: 'Nome',
    type: 'text',
    placeholder: 'Informe o nome da categoria ...',
  },
];

const title = 'Cadastro de Impostos';

export const cadastro = {
  title: title,
  cadastro: Tablecadastro,
};

export const table = {
  header: tableHeader,
  type: 'categoria',
};
